/**
 * 数组相关方法集
 * */
import check from './check.js'
export default {
    getIndexByKey (list, key, value) {
        if (!check.isArray(list) || !Array.findIndex) {
            return false
        }
        return list.findIndex(item => {
            return item[key] === value
        })
    },
    getItemByKey (list, key, value) {
        if (!check.isArray(list) || !Array.find) {
            return false
        }
        return list.find(item => {
            return item[key] === value
        })
    },
    deleteItemByKey (list, key, value) {
        if (!check.isArray(list)) {
            return
        }
        for (let i = 0; i < list.length; i++) {
            if (list[i][key] == value) {
                return list.splice(i, 1)[0]
            }
        }
        return
    }
}
